export function isString(value): boolean {
    return typeof value === 'string' || value instanceof String;
}
